import { styled } from '@volue/wave-react';
import { ReactComponent as LogoSvg } from '@volue/wave/dist/core/images/logomark.svg';
import React from 'react';

const Logo = styled(LogoSvg, {
  height: 32,
  width: 32,
  '& > path': { fill: '$colorWhite' }
});

export function LogoTitle() {
  return (
    <a
      href=""
      className="linkClean dF aiC ofH"
      onClick={() => window.location.reload()}
    >
      <span className="sidebarNav-headerTopLogo">
        <Logo />
      </span>
      <span className="sidebarNav-headerTopTitle delta pRs txtTruncate">
        {'Grid Calculator'}
      </span>
      <span className="sidebarNav-headerTopCurrentPageTitle delta txtTruncate">
        {'Grid Calculator'}
      </span>
    </a>
  );
}
